<template>
  <div class="chat" :class="[active && 'is-active', activeDialog && 'dialog-active']">
    <div class="chat__wrapper">
      <div class="chat__widget" v-click-outside="handleOutsideClick">
        <div class="chat__list-wrapper">
          <div class="chat__list">
            <div class="chat__list-content">
              <Dialog
                theme="simple"
                v-for="dialog in groupsWithSearch"
                :key="dialog.id"
                :dialog="dialog"
                :selected="selectedMembers.includes(dialog.id)"
                @setDialog="setDialog"
              />
            </div>
            <div v-if="isAdmin" class="chat__list-action">
              <button class="gray big" @click="openCreateGroup">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 5.5H15" stroke="#003882" stroke-width="2" stroke-linecap="round"/>
                  <path d="M3 5.5V12.5C3 14.1569 4.34315 15.5 6 15.5H10C11.6569 15.5 13 14.1569 13 12.5V5.5" stroke="#003882" stroke-width="2"/>
                  <path d="M5 2.5H11" stroke="#003882" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>{{ $t('chat.create-group-btn') }}</span>
              </button>
            </div>

          </div>
        </div>
        <div class="chat__close-mobile" @click="handleTriggerClick"></div>

        <!-- <div class="dev chat__active-dialog">Dialog: {{ activeDialog }}</div> -->

        <div v-if="socket.error || socket.reconnectError" class="chat__error">
          <p>{{ socket.error || $t('chat.home.error') }}</p>
          <!-- <button @click="rebuildSocket">Обновить</button> -->
        </div>

        <!-- panel Create Group-->
        <ChatPanel class="chat__panel--group" data-id="group" :class="[tab === 'group' && !activeDialog && 'is-active']">
          <div class="chat-panel__title chat__panel--group-title">
            {{ $t('chat.home.create-group') }}
            <svg @click="tab = 'chats'" class="chat__panel--group-back chat__panel--group-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12.7798H20M5 12.7798L10.7411 6.5M5 12.7798L10.7411 19.0595" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg @click="tab = 'chats'" class="chat__panel--group-close chat__panel--group-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.69727 7.19672L17.3039 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
              <path d="M17.3037 7.19672L6.69711 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
            </svg>

          </div>

<!--          <div class="chat-panel__search">-->
<!--            <SearchHelper v-model="search.group" :placeholder="$t('chat.home.search-placeholder')" />-->
<!--          </div>-->

          <CreateGroup
            :active="tab === 'group'"
            :search="search.group"
            @onSubmit="handleGroupAdded"
          />
        </ChatPanel>


        <ChatPanel class="chat__panel--group" data-id="group" :class="[messagesView === 'edit' && 'is-active']">
          <div class="chat-panel__title chat__panel--group-title">
            {{ $t('chat.home.edit-group') }}
            <svg @click="messagesView = 'main'" class="chat__panel--group-back chat__panel--group-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12.7798H20M5 12.7798L10.7411 6.5M5 12.7798L10.7411 19.0595" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg @click="messagesView = 'main'" class="chat__panel--group-close chat__panel--group-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.69727 7.19672L17.3039 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
              <path d="M17.3037 7.19672L6.69711 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
            </svg>

          </div>

          <CreateGroup
            :active-dialog="dialogActiveInfo"
            :active="messagesView === 'edit'"
            :search="search.group"
            @onSubmit="handleGroupAdded"
          />
        </ChatPanel>

        <!-- panel Attendees -->
        <ChatPanel data-id="attendees" :class="[tab === 'attendees' && !activeDialog && 'is-active']">
          <div class="chat-panel__title">{{ $t('chat.home.participants') }}</div>

          <div class="chat-panel__search">
            <SearchHelper v-model="search.attendees" :placeholder="$t('chat.home.attendees-search-placeholder')" />
          </div>

          <div class="chat__members" v-for="group in membersGroupedWithSearch" :key="group.key">
            <div class="chat__members-key">{{ group.key }}</div>
            <Member v-for="member in group.list" :key="member.id" :data="member" :includePopover="true" />
          </div>
        </ChatPanel>

        <!-- panel ChatView Main-->
        <ChatPanel
          class="chat__panel--messages"
          data-id="messages"
          :class="[messagesView === 'main' && activeDialog && 'is-active']"
        >
          <HeadInfo
            :head="headActive"
            :selectedMode="selectedMode"
            :isAdmin="isAdmin"
            @handleClickBack="handleOutsideClick"
            @changeView="changeMessagesView"
            @selectDone="selectModeHandle"
          />

          <div ref="dialogs" class="chat__dialog">
            <div v-if="scrollMessages.isLoading" class="chat__dialog-loader">
              <Loader theme="block" :loading="true" />
            </div>
            <Messages
              :active-dialog="activeDialog"
              :messages="messages"
              :isAdmin="isAdmin"
              :selected="selectedMessages"
              @select="handleSelectMessage"
              @select-mode="selectModeHandle"
              @reply="replyModeHandle"
              @forward="forwardHandle"
            />
          </div>
          <div v-if="replyMessage !== null" class="chat__reply">
            <div class="chat__reply-body">
              <div class="chat__reply-author">
                {{ replyMessage.author.first_name }} {{ replyMessage.author.last_name }}
              </div>
              <div class="chat__reply-content" v-html="replyMessage.content"></div>
              <div class="chat__reply-close" @click="replyMessage = null">
                <svg width="16" height="16" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.69727 7.19672L17.3039 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
                  <path d="M17.3037 7.19672L6.69711 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="chat__submit">
            <Submit
              @onSubmit="handleSendMsg"
              @forwardSelected="forwardSelected"
              :replyMessage="replyMessage"
              :selectedMode="selectedMode"
              :count="selectedMessages.length"
            />
          </div>
        </ChatPanel>

        <!-- panel ChatView Info-->
        <ChatPanel
          class="chat__panel--messages"
          data-id="messages"
          :class="[messagesView === 'info' && activeDialog && 'is-active']"
        >
          <HeadInfo
            :head="headActive"
            :selectedMode="selectedMode"
            :isAdmin="isAdmin"
            title="Info"
            @handleClickBack="messagesView = 'main'"
            @changeView="changeMessagesView"
            @selectDone="selectModeHandle"
          />

          <div class="chat__info">
<!--            <ChatInfo />-->

            <div class="chat__info-members">
              <Member
                v-for="member in headActive.members"
                :key="member.id"
                theme="simple"
                :data="member"
                :includePopover="true"
              />
            </div>
          </div>
        </ChatPanel>

        <!-- panel ChatView members-->
        <ChatPanel
          class="chat__panel--messages"
          data-id="messages"
          :class="[messagesView === 'members' && activeDialog && 'is-active']"
        >
          <HeadInfo
            :head="headActive"
            :selectedMode="selectedMode"
            :isAdmin="isAdmin"
            title="Info"
            @handleClickBack="messagesView = 'main'"
            @changeView="changeMessagesView"
            @selectDone="selectModeHandle"
          />

          <div class="chat__info">
            <Member
              v-for="member in groupMembersAddList"
              :key="member.id"
              theme="simple"
              :data="member"
              :is-selectable="true"
              :selected="selectedMembers.includes(member.id)"
              @changeSelection="changeMemberSelection"
            />
          </div>
          <div class="c-group__cta">
            <button v-if="messagesView === 'members'" @click.prevent="saveMembersGroup" class="blue large">{{ $t('save') }}</button>
            <button v-else @click.prevent="saveMembersGroup" class="blue large">{{ $t('chat.home.create-group') }}</button>
          </div>
        </ChatPanel>

        <!-- panel Chats -->
        <ChatPanel
          v-if="false"
          class="chat-panel"
          data-id="chats"
          :class="[tab === 'chats' && !activeDialog && 'is-active']"
        >
          <div class="chat-panel__title">{{ $t('chat.home.chats') }}</div>

          <div class="chat-panel__search">
            <SearchHelper v-model="search.chats" :placeholder="$t('chat.home.attendees-search-placeholder')" />
          </div>

          <div class="chat__users">
            <Swiper :options="swiperOptions">
              <SwiperSlide v-for="member in members" :key="member.id">
                <Member :data="member" theme="mini" @changeSelection="selectUserHandler(member)" />
              </SwiperSlide>
            </Swiper>
          </div>

          <Dialogs :dialogs="groupsWithSearch" :setDialog="setDialog" :search="search.chats" />
        </ChatPanel>

        <!-- tabs -->

      </div>
    </div>
    <button
      class="primary chat-trigger"
      :class="{ 'pinned-down': pinnedDown }"
      @click="handleTriggerClick"
    >
      <img src="@/assets/icons/chat-message.svg" :alt="$t('chat.home.open-chat-image-label')" />
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import throttle from 'lodash/throttle'
import { withUi } from '@/components/ui'
import outsize from '@/mixins/outsize'
import { scrollToEnd } from '@/utils/scroll'

import TabsNav from './TabsNav'
import SearchHelper from './SearchHelper'
import HeadInfo from './HeadInfo'

import ChatPanel from './ChatPanel'
import CreateGroup from './CreateGroup'
import Dialogs from './Dialogs'
import Dialog from './Dialog'
import Member from './Member'
import Submit from './Submit'
import ChatInfo from './ChatInfo'
import Messages from './Messages'

import testIcon from '@/assets/icons/sort-arrow.svg?raw'
import { messageForwardService } from '@/store/chat/chat-api'

export default {
  components: {
    ChatPanel,
    TabsNav,
    SearchHelper,
    HeadInfo,
    Dialogs,
    Dialog,
    CreateGroup,
    Member,
    Messages,
    Submit,
    ChatInfo,
  },
  mixins: [outsize, withUi],
  props: {
    pinnedDown: Boolean,
  },
  data: () => ({
    testMessage: [
      {
        author: { id: '1', avatar: testIcon, last_action_at: '123' },
        id: 1,
        read: true,
        content: 'test',
        type: { id: 1 },
      }],
    active: false,
    tab: 'chats', // 'group', 'attendees'
    messagesView: 'main', // 'info', 'profile', 'members'
    selectedMembers: [],
    replyMessage: null,
    search: {
      group: '',
      attendees: '',
      chats: '',
    },
    scrollMessages: {
      lastScroll: null,
      direction: null,
      isLoading: false,
    },
    swiperOptions: {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      freeModeSticky: true,
      slidesOffsetBefore: 30,
      slidesOfffsetAfter: 30,
    },
    selectedMessages: [],
  }),
  computed: {
    dialogActiveInfo() {
      return this.groups?.find((x) => x.id === this.activeDialog);
    },
    isAdmin() {
      return this.$auth.user()?.chat_role === 'chat_admin';
    },
    selectedMode() {
      return !!this.selectedMessages?.length;
    },
    isTabsHidden() {
      if (['profile'].includes(this.messagesView)) {
        return true
      }
      return this.activeDialog ? true : false
    },
    membersGroupedWithSearch() {
      return this.membersGroupedSearch(this.search.attendees)
    },
    groupsWithSearch() {
      return this.groupsSearch(this.search.chats)
    },
    groupMembersAddList() {
      if (this.members && this.members.length) {
        const allIds = this.members.map((x) => x.id)
        const activeIds =
          (this.headActive.members && this.headActive.members.length && this.headActive.members.map((x) => x.id)) || []

        const availableIds = allIds.filter((x) => !activeIds.includes(x))

        return this.members.filter((x) => availableIds.includes(x.id))
      }

      return []
    },
    currentUserId() {
      return this.$auth.user()?.id;
    },
    ...mapGetters('chat', [
      'activeDialog',
      'groups',
      'groupsSearch',
      'messages',
      'members',
      'membersGrouped',
      'membersGroupedSearch',
      'headActive',
      'socket',
      'isConnected',
    ]),
  },
  created() {
    this.scrollDialogsWithThrottle = throttle(this.handleDialogScroll, 300)
  },
  mounted() {
    if (this.$refs.dialogs) {
      this.$refs.dialogs.addEventListener('scroll', this.scrollDialogsWithThrottle, false)
    }

    this.getGroups()
    this.getMembers()
  },
  beforeDestroy() {
    if (this.$refs.dialogs) {
      this.$refs.dialogs.removeEventListener('scroll', this.scrollDialogsWithThrottle, false)
    }
  },
  methods: {
    openCreateGroup(){
      this.changeMessagesView('main');
      this.tab = 'group';
    },
    handleSendMsg() {
      this.replyMessage = null;
      this.scrollDialogsToBottom();
    },
    selectDone() {
      this.selectedMessages = []
    },
    selectModeHandle() {
      this.selectedMessages = []
    },
    async forwardSelected({ message, chat }) {

    },
    async forwardHandle({ message, chat }) {
      await messageForwardService({
        group_id: chat.id,
      }, message.id);
      await this.setDialog(chat.id);
    },
    replyModeHandle(msg) {
      this.replyMessage = msg;
      this.getMessages();
    },
    handleSelectMessage(msg) {
      const id = msg.id;
      if (this.selectedMessages.includes(id)) {
        this.selectedMessages = this.selectedMessages.filter((item) => item !== id)
      } else {
        this.selectedMessages.push(msg.id)
      }
    },
    changeMessagesView(v) {
      this.messagesView = v
      if (v === 'main') {
        this.setActiveDialog(null)
      }
    },
    changeMemberSelection(id) {
      if (!this.selectedMembers.includes(id)) {
        this.selectedMembers = [...this.selectedMembers, id]
      } else {
        this.selectedMembers = this.selectedMembers.filter((x) => x !== id)
      }
    },
    async saveMembersGroup() {
      if (this.selectedMembers.length) {
        this.selectedMembers.forEach((m) => {
          const isActiveMember =
            this.headActive.members && this.headActive.members.length && this.headActive.members.find((x) => x.id === m)

          if (isActiveMember) {
            // drop ?
          } else {
            this.addMember({ group: this.activeDialog, user_id: m }).catch((err) => {
              this.$toast({ type: 'error', title: err.message })
            })
          }
        })
      }
    },
    handleGroupAdded(id) {
      this.setDialog(id)
    },
    async setDialog(id) {
      this.messagesView = 'main'
      // await this.getMessages({ id })
      this.setActiveDialog(id)
      this.setEditable({
        id: null,
        text: null,
      });
      console.log(id, this.groups.find((item) => item.id === id));

      setTimeout(() => {
        scrollToEnd(0, this.$refs.dialogs)
      }, 200)
    },
    handleTriggerClick(e) {
      e.stopPropagation()

      this.active = !this.active
    },
    handleOutsideClick(e) {
      this.setActiveDialog(null)
      if (this.active) {
        this.active = false
      }
    },
    // dialog logic
    handleDialogScroll() {
      if (!this.$refs.dialogs) return

      // const { scrollTop } = this.$refs.dialogs
      // const { lastScroll, direction, isLoading } = this.scrollMessages

      // if (direction === 'up' && scrollTop <= 250 && !isLoading) {
      //   const { total, limit, offset } = this.messagesMeta
      //   if (total > limit + offset) {
      //     this.scrollMessages.isLoading = true
      //     await this.getMessages({ id: this.activeDialog, offset: offset + limit })
      //     this.scrollMessages.isLoading = false
      //   }
      // }

      // this.scrollMessages.direction = scrollTop >= lastScroll ? 'down' : 'up'
      // this.scrollMessages.lastScroll = scrollTop

      this.readMessages()
    },
    async selectUserHandler(user) {
      await this.createGroupP2P(user)
    },
    readMessages() {
      const { offsetHeight } = this.$refs.dialogs
      const dialogsTop = this.$refs.dialogs.getBoundingClientRect().top
      const messages = this.$refs.dialogs.querySelectorAll('.message--outcoming[data-read="false"]')

      // console.log('readMessages scroll func', messages)
      if (!messages) return

      messages.forEach((message) => {
        const rect = message.getBoundingClientRect()
        const isVisible = rect.top - dialogsTop >= 0 && rect.top - rect.height <= offsetHeight

        if (isVisible) {
          // console.log('reading message', message.getAttribute('data-id'))
          this.readMessage({
            id: message.getAttribute('data-id'),
            dialog_id: this.activeDialog,
          })
        }
      })
    },
    scrollDialogsToBottom() {
      scrollToEnd(500, this.$refs.dialogs)
    },
    ...mapActions('chat', [
      'connect',
      'disconnect',
      'getMembers',
      'addMember',
      'dropMember',
      'getMessages',
      'readMessage',
      'getGroups',
      'createGroupP2P',
    ]),
    ...mapMutations('chat', ['setActiveDialog', 'resetMessages', 'setEditable']),
  },
  watch: {
    currentUserId() {
      this.getMembers();
      this.getGroups();
    },
    async activeDialog(id) {
      if (id) {
        this.active = id
        await this.getMessages({ group_id: id })
        this.readMessages()
        this.tab = 'chats'
      }
    },
    messages(newVal, oldVal) {
      const { scrollTop, scrollHeight, offsetHeight } = this.$refs.dialogs
      const scrollBottom = scrollHeight - scrollTop - offsetHeight

      // prevent scrolling if user reading prev. messages or new messages loaded on 'up' scroll
      const hasChangedDialog = (newVal.length && newVal[0].group.id) !== (oldVal.length && oldVal[0].group.id)

      if (scrollBottom <= 50 && !hasChangedDialog) {
        scrollToEnd(500, this.$refs.dialogs)
      }

      // check read status if no scroll height (scroll event wont be triggered)
      if (scrollHeight <= offsetHeight) {
        setTimeout(() => {
          this.readMessages()
        }, 200)
      }
    },
  },
}
</script>

<style lang="scss">
.chat {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  backface-visibility: hidden;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  color: $darkGrey;

  &__wrapper {
    position: relative;
    z-index: 2;
    flex: 1 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    pointer-events: none;
    backface-visibility: hidden;
    visibility: hidden;
  }

  &__widget {
    position: relative;
    z-index: 2;
    overflow: hidden;
    width: 100%;
    max-width: 702px;
    height: 100vh;
    min-height: 1px;
    display: flex;
    opacity: 0;
    background: #ffffff;
    box-shadow: 0px 16px 89px rgba(180, 187, 198, 0.31);
    transition: opacity 0.25s ease-in-out;

    @include mobile {
      padding-top: 26px;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
    height: 100%;
    width: 335px;
    padding: 20px 20px 72px 20px;
    border-right: 1px solid #F2F2F2;

    &-wrapper {
      position: relative;
    }

    &-action {
      position: absolute;
      bottom: 0px;
      left: 0;
      right: 0;
      z-index: 9;
      padding: 0 20px 24px 20px;
      background: #FFFFFF;

      button {
        width: 100%;
      }
    }
  }

  &.dialog-active &__list {
    @include mobile {
      display: none;
    }
  }

  &__close-mobile {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    justify-content: center;
    align-self: center;
    padding: 10px;
    cursor: pointer;

    &::after {
      display: inline-block;
      content: '';
      width: 48px;
      height: 6px;
      background: $dark;
      border-radius: 10px;
      transition: background 0.25s $ease;
    }

    &:hover {
      &::after {
        background: $red;
      }
    }
  }

  &__panel {
    flex: 1 1 auto;
    display: none;
    flex-direction: column;
    opacity: 0;
    transform: translate3d(7px, 0px, 0);
    will-change: transform;
    backface-visibility: hidden;
    pointer-events: none;
    transition: opacity 0.1s ease-out, transform 0.2s $ease;

    &--group {
      .chat-panel__scroller {
        padding: 0 0 32px 0;
      }

      &-title {
        position: relative;
        text-align: center;
        padding: 26px 36px 16px 36px;
        border-bottom: 1px solid #F2F2F2;
      }

      &-icon {
        position: absolute;
        bottom: 16px;
        height: 24px;
        width: 24px;
        cursor: pointer;
      }

      &-back {
        left: 24px;
      }

      &-close {
        right: 24px;
      }
    }

    &--messages {

      .chat-panel__scroller {
        padding: 0;
      }
    }

    &--messenger {
      opacity: 0;
      display: none;
      transform: none;
      pointer-events: all;

      .chat-panel__scroller {
        padding: 0;
      }
    }

    &.is-active {
      display: flex;
      opacity: 1;
      transform: none;
      pointer-events: all;
      width: 367px;
    }
  }

  &__users {
    display: flex;
    margin-top: 36px;
    margin-left: -36px;
    margin-right: -36px;

    .swiper-container {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }

    .swiper-slide {
      flex: 0 0 auto;
      width: auto;
    }
  }

  &__info {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 80px;
    -webkit-touch-overflow: auto;
  }

  &__info-members {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 28px;
  }

  &__members {
    margin-top: 8px;
  }

  &__members-key {
    font-size: 14px;
    line-height: 178.5%;
    color: $dark;
  }

  &__dialog {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }

  &__reply {
    position: relative;
    padding: 8px 24px 8px 8px;
    background: #FFFFFF;
    transform: translateX(-1px);
    border-top: 1px solid #F2F2F2;

    @include mobile {
      padding: 8px 24px;
    }

    &-body {
      padding-left: 16px;
      border-left: 2px solid #003882;
    }

    &-author {
      font-size: 15px;
      font-weight: 700;
      line-height: 20px;
    }

    &-content {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-close {
      position: absolute;
      top: 8px;
      right: 24px;
      cursor: pointer;
    }
  }

  &.is-active {
    .chat__wrapper {
      pointer-events: all;
      visibility: visible;
    }

    .chat__widget {
      opacity: 1;
    }
  }
}

button.chat-trigger.primary  {
  position: absolute;
  z-index: 1;
  pointer-events: all;
  min-width: 50px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 50px;
  right: 50px;
  padding: 0;
  box-shadow: -4px 4px 20px rgba($primary, 0.52);
  border-radius: 15px;
  cursor: pointer;

  &.pinned-down {
    bottom: 15px;
    right: 15px;
  }

  > img {
    margin: 0;
  }
}

@media (max-width: 576px) {
  .chat {
    &__wrapper {
      padding-bottom: 0px;
      padding-right: 0px;
    }

    &__close-mobile {
      display: flex;
    }

    &__widget {
      flex: 1 0 auto;
      height: 100%;
      max-height: 100vh;
      border-radius: 0;
      max-width: 100%;
    }
  }
  .chat-trigger {
    bottom: 20px;
    right: 20px;
  }
}
</style>
